<template>
  <div class="home-tab">
    <ul class="tabs">
      <li
        v-for="(item, index) in tabs"
        :key="index"
        class="tab"
        :class="{ 'is-active': curTab === index, 'three-column-style': showCount == 3 }"
      >
        <a
          href="javascript:"
          :class="item.className"
          @click="changeTab(index)"
        >
          <span class="tabs-a">
            <img :src="curTab === index ? item.active_icon: item.icon">
            <span>{{ item.text }}</span>
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default () {
        return []
      }
    },
    curTab: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
    }
  },
  computed: {
    showCount () {
      /* eslint-disable-next-line */
      return this.tabs.filter(i => i.isShow == true).length
    }
  },
  mounted () {},
  methods: {
    changeTab (index) {
      this.$emit('changeTab', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  height: 50px;
  line-height: 50px;
}
.tab {
  flex: 1;
  text-align: center;
  border: 1px solid #ede3b1;
  border-left: none;
  border-top: none;
  background: #fff7d4;
  a {
    font-size: 16px;
    color: #b07400;
    display: block;
    font-weight: 600;
    &:hover {
      .super-member-tips {
        display: block;
      }
    }
  }
  &:first-child {
    border-left: none;
  }
  &:last-child {
    border-right: none;
  }
  .welfare {
    .tip {
      color: #ff0000;
    }
  }

  .tip {
    color: #b07400;
    font-size: 13px;
  }
  .tabs-a {
    position: relative;
    display: inline-block;
    line-height: 50px;

    img {
      vertical-align: -2px;
      margin-right: 6px;
    }
  }
  &.is-active {
    border-top: none;
    border-bottom: none;
    background: #fff;
    a {
      color: #333;
    }
    .tip {
      color: #732d0a;
    }
  }
  .welfare {
    .tip {
      color: #ff0000;
      font-size: 12px;
    }
  }
  .dubavip {
    img {
      vertical-align: -2px;
    }
  }
  .supervip {
    img {
      vertical-align: -2px;
    }
  }
  img.corner-mark {
    vertical-align: 11px;
    margin-right: 0;
  }
}
.three-column-style {
  flex: none;
  &:first-child {
    width: 36%;
  }
  &:nth-child(2) {
    width: 36%;
  }
  &:nth-child(3) {
    width: 27.6%;
  }
}
</style>
